<template>
	<div class="panel_sale">
		<saleTableGiftCard></saleTableGiftCard>
		<div class="settlementBox">
			<saleGiftCardSettlement></saleGiftCardSettlement>
		</div>
	</div>
</template>
<script>
	import saleTableGiftCard from "./comp/sale_giftCard.vue"
	import saleGiftCardSettlement from "./comp/sale_giftCard_settlement.vue"
	export default {
		components:{saleTableGiftCard,saleGiftCardSettlement},
		data(){
			return{
				
			}
		},
		mounted(){
			this.$store.dispatch("mendian/get_unPayOrderList")
		},
		methods: {
			
		},
	}
</script>
<style scoped lang="scss">
.panel_sale{
	position: relative;
	width:100%;
	height: 100%;
	background-color: #fff;
	.settlementBox{
		position: absolute;
		bottom:0;
		width:100%;
	}
}
</style>
